/* eslint-disable no-plusplus */
<template>
  <svg class="loading-spinner">
    <circle
      :cx="circlePositions[index] && circlePositions[index].x"
      :cy="circlePositions[index] && circlePositions[index].y"
      :r="item.radius"
      :fill="item.color"
      v-for="(item, index) in circles"
      :key="index"/>
  </svg>
</template>

<script>
const CENTER_X = 50;
const CENTER_Y = 50;
const RADIUS = 20;

function toRadians(angle) {
  // eslint-disable-next-line no-mixed-operators
  return angle * Math.PI / 180;
}

function positionOnCircle(radius, angle, center) {
  return {
    x: center.x + (radius * Math.cos(toRadians(angle))),
    y: center.y + (radius * Math.sin(toRadians(angle))),
  };
}

function calculatePositions(component) {
  const angleIncrement = 360 / component.circles.length;
  const positions = {};
  component.circles.forEach((circle, index) => {
    positions[index] = positionOnCircle(
      RADIUS,
      angleIncrement * index,
      { x: CENTER_X, y: CENTER_Y },
    );
  });
  return positions;
}

export default {
  data() {
    return {
      circles: [
        { color: '#dfacf2', radius: 0 },
        { color: '#d888f7', radius: 0 },
        { color: '#d6a0eb', radius: 0 },
        { color: '#cd8ae6', radius: 0 },
        { color: '#b45bd4', radius: 0 },
        { color: '#9f4abd', radius: 0 },
        { color: '#8327a3', radius: 0 },
        { color: '#6c098f', radius: 0 },
        { color: '#550073', radius: 0 },
      ],
      counter: 0,
      interval: null,
    };
  },
  computed: {
    circlePositions: calculatePositions,
  },
  created() {
    this.interval = setInterval(() => {
      // eslint-disable-next-line no-plusplus
      this.counter++;
      this.circles = this.circles.map((item, index) => ({
        ...item,
        radius: (this.counter + index) % 8,
      }));
    }, 70);
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.loading-spinner {
  width: 100px;
  height: 100px;
}
</style>
